namespace GeniuzPOS.CustomReport {
    export interface ReportCusSaleReportForm {
    }

    export class ReportCusSaleReportForm extends Serenity.PrefixedContext {
        static formKey = 'CustomReport.ReportCusSaleReport';
    }
}
